import React, { forwardRef } from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledContentArea = styled(Box)(({ theme, sx }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '10px',
    flex: '1 0 0',
    alignSelf: 'stretch',
    overflow: 'auto',
    touchAction: 'pan-y pan-x', // 수직 스크롤과 수평 스와이프 모두 허용
    // 스크롤 중에도 이벤트가 전달되도록 설정
    WebkitOverflowScrolling: 'touch',
    paddingBottom: '80px',
    //    paddingBottom: '130px',
    ...sx,
}));

const ContentArea = forwardRef((props, ref) => {
    return <StyledContentArea ref={ref} {...props} />;
});

ContentArea.displayName = 'ContentArea';

export default ContentArea;
